//Formik
import { useField } from "formik"

//Style
import styles from "../../styles/Form-Inputs.module.css"

//PrimeReact
import { Skeleton } from "primereact/skeleton"
import { RadioButton } from "primereact/radiobutton"
import { SelectButton } from "primereact/selectbutton"

export default function FormikRadioButtonInput({
  name,
  label,
  helpText,
  required,
  options,
  optionLabel,
  optionValue,
  isInitialLoad,
  disabled,
  className,
  useSelectButton,
}) {
  const [field, meta, helpers] = useField(name)

  const LabelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <label>
          {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
      )
    }
  }

  const getRadio = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else if (useSelectButton) {
      return (
        <div className="radioGroup">
          <SelectButton
            value={field.value}
            onChange={(e) => {
              if (e.value !== null) {
                helpers.setValue(e.value)
              }
            }}
            options={options}
            optionLabel={optionLabel}
            optionValue={optionValue}
            disabled={disabled}
          />
        </div>
      )
    } else {
      return (
        <div className="radioGroup">
          {options.map((option, index) => (
            <div className="radioContainer" key={`_${index}`}>
              <RadioButton
                checked={field.value === option[optionValue]}
                onChange={(e) => {
                  helpers.setValue(option[optionValue])
                }}
                className={`radioButton ${
                  meta.touched && meta.error ? "p-invalid" : ""
                }`}
                inputId={option[optionValue]}
                disabled={disabled}
              />
              <label
                htmlFor={option[optionValue]}
                className="radioLabel"
                style={{ paddingLeft: "8px" }}
              >
                {option[optionLabel]}
              </label>
            </div>
          ))}

          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </div>
      )
    }
  }

  return (
    <div className={`${styles.field} ${className || ""}`}>
      <LabelField />
      <div>
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {getRadio()}
      </div>
    </div>
  )
}
